import { render } from "./aBtnSm.vue?vue&type=template&id=39b230dd&ts=true"
import script from "./aBtnSm.vue?vue&type=script&lang=ts"
export * from "./aBtnSm.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__